import { useOrganisationPeek } from '@jobilla/nexus-sdk/lib/hooks/useOrganisation'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Centered } from '../components/Centered'
import { LoginForm } from '../components/LoginForm'

export const Route = createFileRoute('/$organisationId/')({
	head: () => ({
		meta: [{ title: 'Jobilla' }],
	}),
	component: OrganisationLoginScreen,
})

function OrganisationLoginScreen() {
	const { organisationId } = Route.useParams()
	const { t } = useTranslation('common')

	const organisationQuery = useOrganisationPeek(organisationId, { retry: 0 })

	if (organisationQuery.isPending) {
		return (
			<Centered>
				<p className="text-sm text-grey-500">{t('login.loading')}</p>
			</Centered>
		)
	}

	if (organisationQuery.isError) {
		const status = (organisationQuery.error as { response?: { status?: number } })?.response?.status
		const messageKey = status === 404 ? 'login.unknown_organisation' : 'login.error'

		return (
			<Centered>
				<p className="text-lg font-medium text-grey-800">{t(`${messageKey}.title`)}</p>
				<p className="max-w-sm text-sm text-grey-500">{t(`${messageKey}.body`)}</p>
			</Centered>
		)
	}

	return <LoginForm heading={organisationQuery.data.name} organisationName={organisationQuery.data.name} />
}
